/**
 * Admin UI theme token — spec 028.
 *
 * The Equabot Admin area (/ai/*) always renders in midnight regardless of the
 * user's app-wide theme preference.  This module exports the resolved theme
 * object so `AdminShell` can pass it to its own `ThemeProvider` without
 * reaching into top-level app state.
 *
 * The `selected` marker mirrors the shape produced by `app.tsx`:
 *   const currentTheme = { ...getTheme(state.theme), selected: state.theme }
 * This allows any themed child component that reads `props.theme.selected`
 * (e.g. comparing to `Themes.MIDNIGHT`) to work correctly inside the shell.
 */
import { midnightTheme, Themes } from '@src/styles/theme'

export const adminMidnightTheme = Object.freeze({
  ...midnightTheme,
  selected: Themes.MIDNIGHT,
})
